import React, { useEffect, useState } from 'react';
import DrawerButton from 'components/form/DrawerButton';
import Error from 'components/form/Error';
import LabelArea from 'components/form/LabelArea';
import Title from 'components/form/Title';
import useSoldOutSubmit from 'hooks/useSoldOutSubmit';
import Scrollbars from 'react-custom-scrollbars-2';
import Select from 'react-select';
import InputAreaDate from 'components/form/InputAreaDate';
import SelectMultipleVehicleCategory from 'components/form/SelectMultipleVehicleCategory';
import SoldOutServices from 'services/SoldOutServices';



const SoldOutDrawer = ({ id }) => {

	const [packageCityPairs, setPackageCityPairs] = useState([
		{ packageType: null, selectedCity: null },
	]);

	const {
		trigger,
		register,
		handleSubmit,
		onSubmit,
		errors,
		loading,
		startDate,
		endDate,
		setEndDate,
		setStartDate,
		vehicleType,
		setVehicleType,
	} = useSoldOutSubmit(id, packageCityPairs, setPackageCityPairs);

	const [hourCity, setHourCity] = useState();
	const [outCity, setOutCity] = useState();
	const [airpickCity, setAirPickCity] = useState();
	const [airdropCity, setAirDropCity] = useState();
	const [holidayCity, setHolidayCity] = useState();


	const fetchCityData = async () => {
		try {
			const response = await SoldOutServices.getAllHourSold();

			if (response?.data && response.data.length > 0) {
				setHourCity(response?.data);
			} else {
				setHourCity();
			}
		} catch (error) {
			console.error("Error fetching vendor data:", error);
			setHourCity();
		}

		try {
			const response = await SoldOutServices.getAllOutSold();

			if (response?.data && response.data.length > 0) {
				setOutCity(response?.data);
			} else {
				setOutCity();
			}
		} catch (error) {
			console.error("Error fetching vendor data:", error);
			setOutCity();
		}

		try {
			const response = await SoldOutServices.getAllHolidaySold();

			if (response?.data && response.data.length > 0) {
				setHolidayCity(response?.data);
			} else {
				setHolidayCity();
			}
		} catch (error) {
			console.error("Error fetching vendor data:", error);
			setHolidayCity();
		}

		try {
			const response = await SoldOutServices.getAllAirDropSold();

			if (response?.data && response.data.length > 0) {
				setAirDropCity(response?.data);
			} else {
				setAirDropCity();
			}
		} catch (error) {
			console.error("Error fetching vendor data:", error);
			setAirDropCity();
		}

		try {
			const response = await SoldOutServices.getAllAirPickSold();

			if (response?.data && response.data.length > 0) {
				setAirPickCity(response?.data);
			} else {
				setAirPickCity();
			}
		} catch (error) {
			console.error("Error fetching vendor data:", error);
			setAirPickCity();
		}
	};
	useEffect(() => {
		fetchCityData();
	}, []);

	const packageOptions = [
		{ value: 'Airport Pickup', label: 'Airport Pickup' },
		{ value: 'Airport Drop', label: 'Airport Drop' },
		{ value: 'Outstation', label: 'Outstation' },
		{ value: 'Hour Rental', label: 'Hour Rental' },
		{ value: 'Holiday Package', label: 'Holiday Package' },
		{ value: 'Oneway', label: 'Oneway' }
	];


	const addPair = () => {
		if (packageCityPairs.length < 6) {
			setPackageCityPairs([...packageCityPairs, { packageType: null, selectedCity: null }]);
		}
	};

	const removePair = (index) => {
		const newPairs = [...packageCityPairs];
		newPairs.splice(index, 1);
		setPackageCityPairs(newPairs);
	};

	const updatePair = (index, field, value) => {
		const newPairs = [...packageCityPairs];
		newPairs[index][field] = value;

		// If packageType is being updated, reset selectedCity
		if (field === 'packageType') {
			newPairs[index].selectedCity = null; // Clear the selected cities
		}
		setPackageCityPairs(newPairs);
	};


	const customSelectStyles = {
		indicatorSeparator: () => ({ display: 'none' }),
	};

	const isAirport = (type) => type === 'Airport Pickup' || type === 'Airport Drop';


	return (
		<>
			<div className="w-full relative p-6 border-b border-gray-100 bg-gray-50 dark:border-gray-700 dark:text-gray-300">
				<Title title={id ? 'Edit Sold Out' : 'Add Sold Out'} />
			</div>

			<Scrollbars className="w-full md:w-7/12 lg:w-8/12 xl:w-8/12 relative dark:bg-gray-700 dark:text-gray-200">
				<form onSubmit={handleSubmit((data) => onSubmit({ ...data, packageCityPairs }))}>
					<div className="px-5 pt-5 flex-grow scrollbar-hide w-full max-h-full pb-20">
						<div className="grid grid-cols-12 gap-y-8 gap-x-5 mb-6 items-center">
							<div className="col-span-6">
								<LabelArea required label="Start Date" />
								<InputAreaDate
									trigger={trigger}
									register={register}
									label="Start Date"
									name="start_date"
									type="date"
									value={startDate}
									onChange={setStartDate}
									min={new Date()}
								/>
								<Error errorName={errors.start_date} />
							</div>
							<div className="col-span-6">
								<LabelArea required label="End Date" />
								<InputAreaDate
									trigger={trigger}
									register={register}
									label="End Date"
									name="end_date"
									type="date"
									value={endDate}
									onChange={setEndDate}
									min={startDate && startDate > new Date() ? startDate : new Date()}
								/>
								<Error errorName={errors.end_date} />
							</div>

							{packageCityPairs.map((pair, index) => (
								<React.Fragment key={index}>
									<div className="col-span-6">
										<LabelArea required label={`Package Type `} />
										<Select
											className=" h-10 text-sm focus:outline-none block w-full bg-white dark:bg-white"
											value={packageOptions.find((opt) => opt.value === pair.packageType)}
											options={packageOptions.map((option) => ({
												...option,
												isDisabled:
													packageCityPairs.some(
														(p, i) => i !== index && p.packageType === option.value
													),
											}))}
											required
											onChange={(option) => updatePair(index, 'packageType', option.value)}
											styles={customSelectStyles}
											onBlur={() => trigger(`package_type_${index}`)}
										/>

									</div>
									<div className="col-span-5">
										<LabelArea required label={isAirport(pair.packageType) ? 'Airports' : 'Cities'} />
										<Select
											className="h-10 text-sm focus:outline-none block w-full bg-white dark:bg-white"
											value={pair.selectedCity} // This will reset when packageType changes
											isMulti
											required
											options={
												pair.packageType === 'Hour Rental'
													? hourCity?.filter(city => !pair.selectedCity?.some(selected => Number(selected.value) === city.id)).map(city => ({ value: city.id, label: city.cityname }))
													: pair.packageType === 'Outstation'
														? outCity?.filter(city => !pair.selectedCity?.some(selected => Number(selected.value) === city.id)).map(city => ({ value: city.id, label: city.cityname }))
														: pair.packageType === 'Holiday Package'
															? holidayCity?.filter(city => !pair.selectedCity?.some(selected => Number(selected.value) === city.id)).map(city => ({ value: city.id, label: city.cityname }))
															: pair.packageType === 'Airport Pickup'
																? airpickCity?.filter(city => !pair.selectedCity?.some(selected => Number(selected.value) === city.id)).map(city => ({ value: city.id, label: city.airportname }))
																: pair.packageType === 'Airport Drop'
																	? airdropCity?.filter(city => !pair.selectedCity?.some(selected => Number(selected.value) === city.id)).map(city => ({ value: city.id_city, label: city.cityname }))
																	: pair.packageType === 'Oneway'
														? outCity?.filter(city => !pair.selectedCity?.some(selected => Number(selected.value) === city.id)).map(city => ({ value: city.id, label: city.cityname })) : []
											}
											onChange={(selectedOptions) => updatePair(index, 'selectedCity', selectedOptions)}
											styles={customSelectStyles}
											placeholder="Select city/airport"
										/>

									</div>

									{id ? null : (<div className="col-span-1 flex items-center mt-6">
										{index === packageCityPairs.length - 1 && packageCityPairs.length < 6 ? (
											<button
												type="button"
												onClick={addPair}
												className="text-green-600 hover:text-green-800"
											>
												<span className='text-2xl'>+</span>
											</button>
										) : (
											<button
												type="button"
												onClick={() => removePair(index)}
												className="text-red-600 hover:text-red-800"
											>
												X
											</button>
										)}
									</div>)}
								</React.Fragment>
							))}

							<div className="col-span-12 customeDropDownInputBox">
								<LabelArea required label="Vehicle Type" />
								<SelectMultipleVehicleCategory
									register={register}
									label="Vehicle Type"
									name="vehicle_type"
									selectedVehicle={vehicleType}
									setSelectedVehicle={setVehicleType}
									type="text"
									placeholder={'--Choose--'}
								/>
								<Error errorName={errors.vehicle_type} />
							</div>
						</div>
					</div>
					<DrawerButton isSubmitting={loading} id={id} title={id ? 'Update' : 'Submit'} />
				</form>
			</Scrollbars>
		</>
	);
};

export default SoldOutDrawer;
